if (globalSettings.jsPublicPath) {
    __webpack_public_path__ = globalSettings.jsPublicPath;
}

var can = require('can');

// suppress System.js error
System.has = function () {
    return false;
};

var loader = {
    modules: {},
    import: function (name) {
        let module = this.modules[name];
        if (module) {
            // wrap into can deferred for using in can-import
            const d = can.Deferred();
            if (module.async) {
                module.fn().then(d.resolve.bind(d)).catch(d.reject.bind(d));
                return d.promise();
            } else {
                d.resolve(module.fn());
                return d;
            }

        } else {
            throw new Error('Cannot find module ' + name);
        }
    },
    require: function (name) {
        let module = this.modules[name];
        if (!module) {
            throw new Error('Cannot find module ' + name);
        }
        if (module.async) {
            throw new Error('Cannot require module ' + name + ' because it async');
        }
        return module.fn();
    },
    register: function (name, fn, async) {
        if (process.env.NODE_ENV === 'development') {
            if (Array.from(arguments).length < 3) {
                console.warn(new Error('webpack.register should contain 3 arguments: name, fn, async'));
            }
        }
        // prefer sync modules for sync stache render
        if (!this.modules[name] || this.modules[name].async) {
            this.modules[name] = {fn, async};
        }
    },
    applyImportPatch: function (target) {
        const originalImport = target.import;
        target.import = (module) => {
            try {
                return this.import(module)
            } catch (e) {
                console.log(e);
                return originalImport.call(target, module);
            }
        }
    }
};

// can-import requirement
loader.register('can/view/stache/stache', function () {
    return require('can/view/stache/stache');
}, false);

if (window.webpack) {
    loader.applyImportPatch(window.webpack);
} else {
    window.webpack = loader;
}

loader.applyImportPatch(can);

if (window.steal) {
    loader.applyImportPatch(window.steal);
} else {
    window.steal = loader;
}
